import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { TopUpWithITFLSStoreStatic } from "./TopUpWithITFLSStoreStatic";


export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const TopUpWithITFLSDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const TopUpWithITFLSStore: TopUpWithITFLSStoreStatic = new TopUpWithITFLSStoreStatic();